import _ from 'lodash';
import React from 'react';
import Select, { components } from 'react-select';
import { isEmpty2 } from '../../common/utils';
import Tooltip from './rcTooltip';

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <span style={props.selectProps.menuIsOpen ? {
                    borderColor: '#566f99 transparent transparent',
                    borderStyle: 'solid',
                    borderWidth: '5px 5px 0',
                    content: " ",
                    transform: 'rotate(180deg)'
                } : {
                        borderColor: '#566f99 transparent transparent',
                        borderStyle: 'solid',
                        borderWidth: '5px 5px 0',
                        content: " ",
                    }}>
                </span>
            </components.DropdownIndicator>
        )
    );
};

const ControlComponent = props => {
    let hideTooltip = props.selectProps.menuIsOpen ? true : (props.selectProps.hideTooltip === undefined ? true : props.selectProps.hideTooltip);
    let tooltipText = props.selectProps.menuIsOpen ? '' : (props.selectProps.hideTooltip === undefined ? '' : props.selectProps.tooltipText);
    return (
        <Tooltip id={props.selectProps.tooltipId} hideTooltip={(hideTooltip || isEmpty2(tooltipText) ? true : false)} text={tooltipText}>
            <div style={{ width: '100%', height: '100%' }}>
                <components.Control {...props} />
            </div>
        </Tooltip>
    )
}

const formatGroupLabel = data => {
    return (
        <div className='grouped-ddl-label-text' >
            <span style={{ color: '#1D3F77' }}>{data.label}</span>
            {/* <div className="grouped-ddl-label-badge">{data.options.length}</div> */}
        </div>
    )
};

class Dropdown extends React.Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this);
    }


    getRenderingOptions() {
        const optionsSelect = this.props.options.map((s) => { return { ...s, value: s[this.props.keyValue ? this.props.keyValue : 'value'], label: s[this.props.keyText ? this.props.keyText : 'label'] } });
        return optionsSelect;
    }

    getSelectedValue(allOptions, value) {
        const optionsSelect = allOptions.filter((s) => { return s.value === value });
        if (optionsSelect.length > 0) {
            return optionsSelect[0];
        } else if (value === this.props.emptyValue) {
            var obj = {};
            obj['value'] = this.props.emptyValue ? this.props.emptyValue : null;
            obj['label'] = this.props.emptyText ? this.props.emptyText : '';
            return obj;
        }

        else {
            return null;
        }
    }

    handleChange = (selectedOption) => {
        if (this.props.onChange) {
            const newState = {};
            newState[this.props.keyValue ? this.props.keyValue : 'value'] = selectedOption ? selectedOption.value : null;
            newState[this.props.keyText ? this.props.keyText : 'label'] = selectedOption ? selectedOption.label : '';;
            this.props.onChange(newState);
            if (this.props.blurOnChange) {
                this.ddl.blur();
            }
        }
    }

    render() {
        const allOptions = this.props.isGrouped ? this.props.options : this.getRenderingOptions();
        const value = this.props.isGrouped ? this.props.selected : this.getSelectedValue(allOptions, this.props.selected);
        let _options = _.assign([], allOptions);

        if (!this.props.showEmptyItem && _options.length > 0) {
            var obj = {};
            obj['value'] = this.props.emptyValue ? this.props.emptyValue : null;
            obj['label'] = this.props.emptyText ? this.props.emptyText : '';
            _options.splice(0, 0, obj);
        }

        const ddlStyle = {
            container: (provided, state) => {
                const _this1 = this.props;
                return (
                    {
                        ...provided,
                        height: _this1.height ? _this1.height : 34,
                        width: _this1.width ? _this1.width : '100%',
                        pointerEvents: state.isDisabled ? 'auto' : provided.pointerEvents,
                    }
                )
            },
            control: (provided, state) => {
                const _this2 = this.props;
                return (
                    {
                        ...provided,
                        borderColor: !state.isFocused ? (_this2.borderColor ? _this2.borderColor : '#b0bcd0') : provided.borderColor,
                        boxShadow: !state.isFocused ? (_this2.boxShadowColor ? ('0 0 6px 0 ' + _this2.boxShadowColor) : '') : (_this2.boxShadowColor ? ('0 0 6px 0 ' + _this2.boxShadowColor) : '0 0 6px 0px #5789fa'),
                        minHeight: _this2.height ? _this2.height : 34,
                        height: _this2.height ? _this2.height : 34,
                        backgroundColor: _this2.background ? _this2.background : provided.backgroundColor,
                        alignContent: 'center',
                        '&:hover': { borderColor: 'auto' },
                    }
                )
            },
            menu: (provided, state) => ({
                ...provided,
                marginTop: 4,
                marginBottom: 0,
                marginLeft: -1,
                width: 'max-content',
                maxwidth: this.props.menuMaxWidth ? this.props.menuMaxWidth : 540,
                border: '1px solid #b0bcd0',
                boxShadow: '0 0 6px 0px #b0bcd0',
                minWidth: 'calc(100% + 2px)',
                zIndex: 10,
            }),
            menuList: (provided, state) => ({
                ...provided,
                paddingTop: 0,
                paddingBottom: 0,
                overflowX: 'hidden',
            }),
            singleValue: (provided, state) => {
                return ({
                    ...provided,
                    color: this.props.color ? this.props.color : '#566F99',
                    textOverflow: 'ellipsis',
                    fontFamily: 'Source Sans Pro',
                    fontWeight: 400,
                    fontSize: this.props.optionFontSize ? this.props.optionFontSize : 16,
                })
            },
            option: (provided, state) => {
                const _this4 = this.props;
                const isFirstOption = state.options.length > 0 ? state.options[0].label === state.label ? true : false : false;
                const isLastOption = state.options.length > 0 ? state.options[state.options.length - 1].label === state.label ? true : false : false;
                return ({
                    ...provided,
                    borderRadius: (state.isFocused || state.isSelected) ? (isFirstOption ? '4px 4px 0px 0px' : isLastOption ? '0px 0px 4px 4px' : '') : '',
                    color: state.isSelected ? '#FFF' : '#566F99',
                    textOverflow: 'ellipsis',
                    fontFamily: 'Source Sans Pro',
                    fontWeight: 400,
                    padding: '0 12px 0 12px',
                    fontSize: _this4.optionFontSize ? _this4.optionFontSize : 16,
                    minHeight: _this4.optionHeight ? _this4.optionHeight : 30,
                    lineHeight: _this4.optionHeight ? _this4.optionHeight + 'px' : '30px'
                })
            },
            indicatorSeparator: (provided, state) => ({ ...provided, width: 0 }),
            menuPortal: (provided, state) => ({ ...provided, zIndex: this.props.isModal ? 1051 : 9 }),
            indicatorsContainer: (provided, state) => ({
                ...provided,
                display: state.isDisabled && this.props.hideArrow ? 'none' : 'flex',
                padding: '0px 8px 0px 0px'
            }),
            dropdownIndicator: (provided, state) => ({ ...provided, padding: 0, marginLeft: 0 }),
            group: () => ({ padding: 0 }),
            groupHeading: () => ({
                background: '#E7F0FE',
                color: '#999',
                cursor: 'default',
                fontWeight: 600,
                textTransform: 'uppercase',
                padding: '4px 10px 4px 11px',
                borderBottom: '2px solid rgb(227, 232, 238)',
                borderTop: '2px solid rgb(227, 232, 238)',
            }),
            placeholder: (provided, state) => {
                const _this5 = this.props;
                return ({
                    ...provided, color: '#8396b4', fontStyle: 'italic', textOverflow: 'ellipsis',
                    fontFamily: 'Source Sans Pro',
                    fontWeight: 400,
                    fontSize: _this5.optionFontSize ? _this5.optionFontSize : 16,
                })
            },
        }
        return (
            <Select
                ref={ref => this.ddl = ref}
                styles={ddlStyle}
                components={{ DropdownIndicator: DropdownIndicator, Control: ControlComponent }}
                hideTooltip={this.props.hideTooltip} tooltipId={this.props.tooltipId}
                tooltipText={this.props.tooltipText}
                onChange={this.props.onChange ? this.handleChange : this._onSelect}
                options={_options}
                isClearable={this.props.isNotClearable ? false : (this.props.isSearchable ? this.props.isSearchable : false)}
                isDisabled={this.props.disabled ? true : false}
                isMulti={this.props.isMulti ? this.props.isMulti : false}
                isSearchable={this.props.isSearchable ? this.props.isSearchable : false}
                placeholder={this.props.placeholder ? this.props.placeholder : (this.props.disabled ? '' : 'Select')}
                value={value}
                menuPlacement={'auto'}
                formatGroupLabel={this.props.isGrouped ? formatGroupLabel : <></>}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        text: '#566F99',
                        primary: '#5789FA',
                        neutral0: '#FFF'
                    },
                })}
                className={this.props.additonalClasses ? (this.props.additonalClasses + '-container') : 'ddl-react-select-container'}
                classNamePrefix={this.props.additonalClasses ? (this.props.additonalClasses) : 'ddl-react-select'}
                autoFocus={this.props.autoFocus ? this.props.autoFocus : false}
            />
        )
    }
}

export default Dropdown;
